import { trigger } from "@angular/animations";

export const disableAnimation = trigger('disableAnimation', []);